import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  @Input() title!: string;
  @Input() confirmActionLabel!: string;
  @Input() notConfirmActionLabel!: string;
  @Input() message!: string;

  constructor(public modalService: NgbActiveModal) {}

  confirm(result: boolean) {
    this.modalService.close(result);
  }

  close() {
    this.modalService.dismiss();
  }
}
